import React from 'react';
import ThumbnailHelper from '../../../pages/widget/previewer/ThumbnailHelper';
import BrowserPreviewer from '../../../pages/widget/previewer//BrowserPreviewer';
import HwzComponent from '../../../common/component/HwzComponent';
import { RouteComponentProps } from 'react-router-dom';
import RemovableStorage from '../../../common/model/removable/RemovableStorage';
import RemovableFileInfo from '../../../common/model/removable/RemovableFileInfo';
import Lang from '../../../common/model/global/Lang';
import './RemovableFileBrowser.less';
import {
  Button,
  Modal,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Input,
  Breadcrumb,
  Dropdown,
  Menu,
  Upload,
  Space as AntdSpace,
  Spin,
  Empty,
  Alert,
  Progress,
  message,
  Checkbox,
  Tooltip,
} from 'antd';
import Moon from '../../../common/model/global/Moon';
import MessageBoxUtil from '../../../common/util/MessageBoxUtil';
import PreviewerHelper from '../../../pages/widget/previewer/PreviewerHelper';
import Matter from '../../../common/model/matter/Matter';
import MimeUtil from '../../../common/util/MimeUtil';

import {
  FolderOutlined,
  FileOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  FileZipOutlined,
  FileExcelOutlined,
  FileWordOutlined,
  FilePptOutlined,
  DownloadOutlined,
  EyeOutlined,
  EditOutlined,
  ArrowLeftOutlined,
  UploadOutlined,
  FolderOpenOutlined,
  HomeOutlined,
  MoreOutlined,
  ReloadOutlined,
  UsbOutlined,
  HddOutlined,
  SaveOutlined,
  FileUnknownOutlined,
  DeleteOutlined,
  PlusOutlined,
  PlayCircleOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  AppstoreOutlined,
  BarsOutlined,
} from '@ant-design/icons';

interface IProps extends RouteComponentProps<{
  deviceId?: string;
}> {}

interface IState {
  devices: RemovableStorage[];
  currentDevice: RemovableStorage | null;
  currentPath: string;
  files: RemovableFileInfo[];
  loading: boolean;
  selectedRowKeys: React.Key[];
  uploadModalVisible: boolean;
  uploadLoading: boolean;
  selectedFile: File | null;
  renameModalVisible: boolean;
  renameLoading: boolean;
  renamingFile: RemovableFileInfo | null;
  newFileName: string;
  previewModalVisible: boolean;
  previewData: any | null;
  previewLoading: boolean;
  pathHistory: string[];
  createDirModalVisible: boolean;
  newDirName: string;
  createDirLoading: boolean;
  deleteModalVisible: boolean;
  deletingFiles: RemovableFileInfo[];
  deleteLoading: boolean;
  mediaPreviewVisible: boolean;
  mediaPreviewUrl: string;
  mediaPreviewType: 'audio' | 'video' | null;
  mediaPreviewName: string;
  mediaPreviewMimeType: string;
  uploadFolderModalVisible: boolean;
  uploadFolderLoading: boolean;
  uploadFolderFiles: File[];
  uploadFolderPaths: string[];
  uploadFolderProgress: number;
  // 新增视图模式
  viewMode: 'list' | 'grid';
}

declare module '../../../common/model/removable/RemovableFileInfo' {
  interface RemovableFileInfo {
    uuid?: string;
    privacy?: boolean;
    spaceUuid?: string;
    userUuid?: string;
    name: string;
    size: number;
    isDir: boolean;
    extension?: string;
    modifiedTime?: string;
    path?: string;
  }
}

export default class RemovableFileBrowser extends HwzComponent<IProps, IState> {
  currentUser = Moon.getSingleton().user;
  
  get deviceId(): string | undefined {
    return this.props.match.params.deviceId;
  }
  
  constructor(props: IProps) {
    super(props);
    
    // 读取本地存储的视图模式
    const savedViewMode = (localStorage.getItem('removable_view_mode') as 'list' | 'grid') || 'list';
    
    this.state = {
      devices: [],
      currentDevice: null,
      currentPath: '',
      files: [],
      loading: false,
      selectedRowKeys: [],
      uploadModalVisible: false,
      uploadLoading: false,
      selectedFile: null,
      renameModalVisible: false,
      renameLoading: false,
      renamingFile: null,
      newFileName: '',
      previewModalVisible: false,
      previewData: null,
      previewLoading: false,
      pathHistory: [],
      createDirModalVisible: false,
      newDirName: '',
      createDirLoading: false,
      deleteModalVisible: false,
      deletingFiles: [],
      deleteLoading: false,
      mediaPreviewVisible: false,
      mediaPreviewUrl: '',
      mediaPreviewType: null,
      mediaPreviewName: '',
      mediaPreviewMimeType: '',
      uploadFolderModalVisible: false,
      uploadFolderLoading: false,
      uploadFolderFiles: [],
      uploadFolderPaths: [],
      uploadFolderProgress: 0,
      viewMode: savedViewMode,
    };
  }

  componentDidMount() {
    if (this.deviceId) {
      this.loadDeviceInfo();
      setTimeout(() => {
        this.browseDirectory('');
      }, 100);
    } else {
      this.loadDeviceList();
    }
  }

  componentDidUpdate(prevProps: IProps) {
    const prevDeviceId = prevProps.match.params.deviceId;
    const currentDeviceId = this.props.match.params.deviceId;
    
    if (prevDeviceId !== currentDeviceId) {
      if (currentDeviceId) {
        this.setState({
          currentDevice: null,
          currentPath: '',
          files: [],
          pathHistory: [],
          loading: true
        }, () => {
          this.loadDeviceInfo();
          setTimeout(() => {
            this.browseDirectory('');
          }, 100);
        });
      } else {
        this.loadDeviceList();
      }
    }
  }

  // ========== 设备列表相关 ==========
  makeDirectRequest = async () => {
    try {
      const response = await fetch('/api/removable/list', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      
      const textResponse = await response.text();
      
      try {
        const jsonResponse = JSON.parse(textResponse);
        this.processResponseData(jsonResponse);
      } catch (parseError) {
        MessageBoxUtil.error(Lang.t('error.invalidFormat'));
        this.setState({ loading: false });
      }
    } catch (error: any) {
      MessageBoxUtil.error(error.message || Lang.t('error.networkError'));
      this.setState({ loading: false });
    }
  };

  processResponseData = (response: any) => {
    let deviceArray = [];
    
    if (response && response.code === "OK") {
      if (response.data && Array.isArray(response.data)) {
        deviceArray = response.data;
      } else if (response.Data && Array.isArray(response.Data)) {
        deviceArray = response.Data;
      }
      
      if (deviceArray.length === 0) {
        this.setState({ devices: [], loading: false });
        MessageBoxUtil.info(Lang.t('removable.noDeviceFound'));
        return;
      }
      
      const devices = deviceArray.map((deviceData: any) => {
        const device = new RemovableStorage();
        device.uuid = deviceData.uuid || deviceData.UUID || '';
        device.deviceId = deviceData.deviceId || deviceData.DeviceID || deviceData.deviceID || '';
        device.name = deviceData.name || deviceData.Name || deviceData.label || deviceData.Label || Lang.t('removable.unknownDevice');
        device.mountPoint = deviceData.mountPoint || deviceData.MountPoint || deviceData.mountpoint || '';
        device.totalSize = deviceData.totalSize || deviceData.TotalSize || deviceData.size || 0;
        device.freeSize = deviceData.freeSize || deviceData.FreeSize || deviceData.free || 0;
        device.usedSize = deviceData.usedSize || deviceData.UsedSize || deviceData.used || 0;
        device.fileSystem = deviceData.fileSystem || deviceData.FileSystem || deviceData.filesystem || '';
        device.status = deviceData.status || deviceData.Status || deviceData.state || 'connected';
        device.isRemovable = deviceData.isRemovable !== undefined ? deviceData.isRemovable : 
                            (deviceData.IsRemovable !== undefined ? deviceData.IsRemovable : true);
        device.connectedAt = deviceData.connectedAt || deviceData.ConnectedAt || '';
        device.lastSeenAt = deviceData.lastSeenAt || deviceData.LastSeenAt || '';
        
        if (device.usedSize === 0 && device.totalSize > 0 && device.freeSize > 0) {
          device.usedSize = device.totalSize - device.freeSize;
        }
        
        return device;
      });
      
      this.setState({ devices, loading: false });
    } else {
      const errorMsg = response?.msg || response?.message || Lang.t('error.operationFailed');
      MessageBoxUtil.error(errorMsg);
      this.setState({ loading: false });
    }
  };

  loadDeviceList = () => {
    this.setState({ loading: true, devices: [] });
    this.makeDirectRequest();
  };

  loadDeviceInfo = () => {
    const deviceId = this.deviceId;
    if (!deviceId) return;
    
    this.setState({ loading: true });
    
    try {
      const storage = new RemovableStorage();
      storage.httpList(
        (response: any) => {
          if (response && (response.code === "OK" || response.code === "SUCCESS" || response.code === 200)) {
            const devices = Array.isArray(response.data) ? response.data.map((deviceData: any) => {
              return new RemovableStorage().safeAssign(deviceData);
            }) : [];
            
            const device = devices.find((d: RemovableStorage) => d.deviceId === deviceId);
            
            if (device) {
              this.setState({ currentDevice: device, loading: false });
            } else {
              MessageBoxUtil.error(Lang.t('error.operationFailed'));
              this.setState({ loading: false });
              setTimeout(() => {
                this.props.history.push('/removable/list');
              }, 2000);
            }
          } else {
            MessageBoxUtil.error(response?.message || Lang.t('error.operationFailed'));
            this.setState({ loading: false });
          }
        },
        (error: string) => {
          MessageBoxUtil.error(error || Lang.t('error.operationFailed'));
          this.setState({ loading: false });
        }
      );
    } catch (error: any) {
      MessageBoxUtil.error(error.message || Lang.t('error.operationFailed'));
      this.setState({ loading: false });
    }
  };

  handleDeviceClick = (device: RemovableStorage) => {
    if (device.deviceId && device.deviceId !== 'N/A') {
      this.props.history.replace(`/removable/browse/${device.deviceId}`);
    } else {
      MessageBoxUtil.error(Lang.t('error.invalidInput'));
    }
  };

  // ========== 文件浏览 ==========
  browseDirectory = (path: string) => {
    const deviceId = this.deviceId;
    if (!deviceId) return;
    
    this.setState({ loading: true, files: [] });
    this.directBrowseRequest(deviceId, path);
  };

  directBrowseRequest = async (deviceId: string, path: string) => {
    try {
      const params = new URLSearchParams();
      params.append('deviceId', deviceId);
      if (path) {
        params.append('path', path);
      }
      
      const url = `/api/removable/browse?${params.toString()}`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      
      const textResponse = await response.text();
      
      if (response.ok) {
        try {
          const jsonResponse = JSON.parse(textResponse);
          
          if (jsonResponse && jsonResponse.code === "OK") {
            const files = jsonResponse.data || [];
            
            const fileList = Array.isArray(files) ? files.map((fileData: any) => {
              const file = new RemovableFileInfo();
              Object.assign(file, fileData);
              return file;
            }) : [];
            
            this.setState({
              files: fileList,
              loading: false,
              currentPath: path,
              selectedRowKeys: []
            });
          } else {
            const errorMsg = jsonResponse?.msg || jsonResponse?.message || '获取文件列表失败';
            MessageBoxUtil.error(errorMsg);
            this.setState({ loading: false });
          }
        } catch (parseError) {
          MessageBoxUtil.error(Lang.t('error.invalidFormat'));
          this.setState({ loading: false });
        }
      } else {
        try {
          const jsonResponse = JSON.parse(textResponse);
          const errorMsg = jsonResponse?.msg || jsonResponse?.message || `HTTP错误: ${response.status}`;
          MessageBoxUtil.error(errorMsg);
        } catch (parseError) {
          MessageBoxUtil.error(`HTTP错误: ${response.status}`);
        }
        this.setState({ loading: false });
      }
    } catch (error: any) {
      MessageBoxUtil.error(error.message || '网络错误');
      this.setState({ loading: false });
    }
  };

  handleDirectoryClick = (file: RemovableFileInfo) => {
    if (!file.isDir) return;
    
    const newPath = this.state.currentPath 
      ? `${this.state.currentPath}/${file.name}`
      : file.name;
    
    const newHistory = [...this.state.pathHistory, this.state.currentPath];
    this.setState({ pathHistory: newHistory }, () => {
      this.browseDirectory(newPath);
    });
  };

  handleGoBack = () => {
    const { pathHistory, currentPath } = this.state;
    
    if (pathHistory.length > 0) {
      const previousPath = pathHistory[pathHistory.length - 1];
      const newHistory = pathHistory.slice(0, -1);
      
      this.setState({ pathHistory: newHistory }, () => {
        this.browseDirectory(previousPath);
      });
    } else if (currentPath) {
      const pathParts = currentPath.split('/');
      pathParts.pop();
      const parentPath = pathParts.join('/');
      
      this.browseDirectory(parentPath);
    }
  };

  handleGoHome = () => {
    this.setState({ pathHistory: [] }, () => {
      this.browseDirectory('');
    });
  };
  private batchDownload = async (items: { path: string; isDir: boolean }[]) => {
    const deviceId = this.deviceId;
    if (!deviceId || items.length === 0) return;
  
    const hideLoading = message.loading('正在准备打包，请稍候...', 0);
    try {
      const response = await fetch('/api/removable/batch-download', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ deviceId, items }),
      });
  
      if (!response.ok) {
        let errorMsg = `HTTP ${response.status}`;
        try {
          const errorData = await response.json();
          errorMsg = errorData.msg || errorData.message || errorMsg;
        } catch {}
        throw new Error(errorMsg);
      }
  
      const disposition = response.headers.get('Content-Disposition');
      let filename = `removable_${Date.now()}.zip`;
      if (disposition && disposition.includes('filename=')) {
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (match && match[1]) filename = match[1].replace(/['"]/g, '');
      }
  
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
  
      hideLoading();
      message.success('打包完成，开始下载');
    } catch (error: any) {
      hideLoading();
      message.error(`下载失败: ${error.message}`);
    }
  };
  // ========== 文件操作 ==========
  /*handleDownload = (file: RemovableFileInfo) => {
    const deviceId = this.deviceId;
    if (!deviceId || file.isDir) {
      if (file.isDir) MessageBoxUtil.info(Lang.t('removable.cannotDownloadDir'));
      return;
    }
    
    const filePath = this.state.currentPath 
      ? `${this.state.currentPath}/${file.name}`
      : file.name;
    
    const params = new URLSearchParams({ deviceId, path: filePath, download: 'true' });
    const downloadUrl = `/api/removable/download?${params.toString()}`;
    
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = file.name;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    
    message.success(Lang.t('matter.downloadStarted'));
  };*/


  /*private handleDownload = async (file?: RemovableFileInfo) => {
    const { selectedRowKeys, files, currentPath } = this.state;
    const deviceId = this.deviceId;
  
    if (!deviceId) return;
  
    // 1. 处理多选（来自工具栏的“下载选中”按钮）
    if (!file) {
      const selectedFiles = files.filter(f => selectedRowKeys.includes(f.path || f.name));
      if (selectedFiles.length === 0) {
        message.info(Lang.t('removable.selectFilesFirst'));
        return;
      }
      const items = selectedFiles.map(f => ({
        path: currentPath ? `${currentPath}/${f.name}` : f.name,
        isDir: f.isDir,
      }));
      await this.batchDownload(items);
      return;
    }
  
    // 2. 处理单个文件或目录（来自行内按钮或右键菜单）
    const itemPath = currentPath ? `${currentPath}/${file.name}` : file.name;
  
    if (file.isDir) {
      // 目录 → 打包下载（调用批量接口）
      await this.batchDownload([{ path: itemPath, isDir: true }]);
    } else {
      // 单个文件 → 仍使用原接口直接下载（避免产生不必要的 ZIP）
      const downloadUrl = `/api/removable/download?deviceId=${deviceId}&path=${encodeURIComponent(itemPath)}`;
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      message.success(Lang.t('matter.downloadStarted'));
    }
  };*/

  private handleDownload = async (file?: RemovableFileInfo) => {
    const { selectedRowKeys, files, currentPath } = this.state;
    const deviceId = this.deviceId;
    if (!deviceId) return;

    let items: { path: string; isDir: boolean }[] = [];

    if (!file) {
        // 多选（工具栏按钮）
        const selectedFiles = files.filter(f => selectedRowKeys.includes(f.path || f.name));
        if (selectedFiles.length === 0) {
            message.info(Lang.t('removable.selectFilesFirst'));
            return;
        }
        items = selectedFiles.map(f => ({
            path: currentPath ? `${currentPath}/${f.name}` : f.name,
            isDir: f.isDir,
        }));
    } else {
        // 单选（三点菜单或卡片下载图标）
        const itemPath = currentPath ? `${currentPath}/${file.name}` : file.name;
        items = [{ path: itemPath, isDir: file.isDir }];
    }

    await this.batchDownload(items);
};
/**
 * 将移动盘的文件信息转换为临时的 Matter 对象，用于复用本地工具类
 */
private convertToFakeMatter(file: RemovableFileInfo): Matter {
  const matter = new Matter();
  matter.name = file.name;
  matter.dir = file.isDir;
  matter.size = file.size;
  // 注意：移动盘的文件没有 uuid、spaceUuid 等，但图标和缩略图只需要 name 和 dir
  return matter;
}
handlePreview = async (file: RemovableFileInfo) => {
  const deviceId = (this.deviceId || '').trim();
  if (!deviceId || file.isDir) return;

  if (!this.canFilePreview(file)) {
    this.showPreviewNotSupported(file);
    return;
  }

  let filePath = file.name.trim();
  if (this.state.currentPath) {
    const currentPath = this.state.currentPath.trim();
    const fileName = file.name.trim();
    filePath = currentPath ? `${currentPath}/${fileName}` : fileName;
  }
  filePath = filePath.trim();

  try {
    const params = new URLSearchParams();
    params.set('deviceId', deviceId);
    params.set('path', filePath);
    const tokenUrl = `/api/removable/preview/token?${params.toString()}`;
    const tokenRes = await fetch(tokenUrl);
    
    if (!tokenRes.ok) {
      if (tokenRes.status === 401 || tokenRes.status === 403 || tokenRes.status === 404) {
        throw new Error(Lang.t('removable.fileUnaccessible'));
      }
      throw new Error(`HTTP ${tokenRes.status}: ${tokenRes.statusText}`);
    }
    
    const tokenData = await tokenRes.json();
    if (tokenData.code !== 'OK') {
      throw new Error(tokenData.msg || Lang.t('removable.previewFailed'));
    }

    const previewUrl = `${window.location.origin}/api/removable/preview?token=${encodeURIComponent(tokenData.data.token)}`;
    const ext = MimeUtil.getExtensionWithoutDot(file.name)?.toLowerCase();
    
    // Office 文件保持原有逻辑
    const OFFICE_EXTS = new Set(['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'vsd', 'vsdx']);
    if (ext && OFFICE_EXTS.has(ext)) {
      PreviewerHelper.previewRemovableOfficeFile(
        file.name,
        file.size || 0,
        previewUrl,
        true,
        false
      );
    } else {
        // 所有非 Office 文件（包括图片、PDF、文本、音视频、CAD 等）统一走 PreviewerHelper.preview
        const virtualMatter = new Matter();
        virtualMatter.name = file.name;
        virtualMatter.size = file.size || 0;
        virtualMatter.privacy = false;
        virtualMatter.uuid = null;                       // 关键：让 PreviewerHelper 识别为移动盘
        (virtualMatter as any).isRemovable = true;      // 明确标记移动盘
        virtualMatter.getPreviewUrl = () => previewUrl;  // 提供 URL（备选）

        // 直接传入 previewUrl，避免内部重新构建
        PreviewerHelper.preview(virtualMatter, previewUrl, true, false);
    }
  } catch (error: any) {
    console.error('预览失败:', error);
    
    if (error.message.includes('不支持') || error.message.includes('无法预览')) {
      this.showPreviewNotSupported(file);
    } else if (error.message.includes('无法访问') || error.message.includes('Unaccessible')) {
      message.error(Lang.t('removable.fileUnaccessible'));
    } else {
      const extension = MimeUtil.getExtensionWithoutDot(file.name)?.toLowerCase() || '';
      const commonPreviewErrors = [
        'unsupported', 'not supported', 'can\'t preview', 'cannot preview',
        'preview failed', '不支持', '无法预览'
      ];
      
      const isPreviewError = commonPreviewErrors.some(keyword => 
        error.message.toLowerCase().includes(keyword)
      );
      
      if (isPreviewError) {
        this.showPreviewNotSupported(file);
      } else {
        message.error(Lang.t('removable.previewFailed') + ': ' + error.message);
      }
    }
  }
};
  showPreviewNotSupported = (file: RemovableFileInfo) => {
    const extension = MimeUtil.getExtensionWithoutDot(file.name)?.toLowerCase() || '未知';
    
    Modal.info({
      title: Lang.t('removable.cannotPreview'),
      content: (
        <div>
          <p>{Lang.t('matter.file')} <strong>{file.name}</strong> {Lang.t('removable.cannotPreview')}。</p>
          <p>{Lang.t('removable.fileType')}: {extension.toUpperCase()}</p>
          <p style={{ marginTop: 16, color: '#666' }}>
            {Lang.t('removable.previewSupportedTypes')}:<br />
            • {Lang.t('removable.imageTypes')}<br />
            • {Lang.t('removable.officeTypes')}<br />
            • {Lang.t('removable.pdfType')}<br />
            • {Lang.t('removable.textTypes')}<br />
            • {Lang.t('removable.audioVideoTypes')}
          </p>
        </div>
      ),
      okText: Lang.t('common.confirm'),
      width: 500,
    });
  };

  isCadType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const cadTypes = ['dxf', 'dwg'];
    return cadTypes.includes(extension);
  };

  isMindMapType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const mindMapTypes = [
      'xmind', 'mm', 'pos', 'eddx', 'mindmup', 'mup', 'nm5', 'nm4', 'nm3', 
      'imx', 'imm', 'mem', 'mmp', 'cdmz', 'cdmm', 'coggle', 'mind', 'km', 
      'mindmap', 'mn', 'mnd', 'mindjet', 'mj', 'mjt', 'mjp', 'brain', 'brn', 
      'thought', 'tht'
    ];
    return mindMapTypes.includes(extension);
  };

  isOfficeType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const officeTypes = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'wps', 'et', 'dps'];
    return officeTypes.includes(extension);
  };

  isImageType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'ico'];
    return imageTypes.includes(extension);
  };

  isTextType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const textTypes = [
      'txt', 'md', 'json', 'xml', 'yaml', 'yml', 'js', 'ts', 'jsx', 'tsx',
      'html', 'htm', 'css', 'scss', 'less', 'csv', 'log', 'ini', 'conf',
      'properties', 'toml', 'sh', 'bash', 'bat', 'cmd', 'ps1'
    ];
    return textTypes.includes(extension);
  };

  isAudioType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const audioTypes = ['mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac', 'wma', 'aiff'];
    return audioTypes.includes(extension);
  };

  isVideoType = (extension: string | undefined): boolean => {
    if (!extension) return false;
    const videoTypes = ['mp4', 'webm', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'm4v', '3gp', 'mpeg', 'mpg'];
    return videoTypes.includes(extension);
  };

  canUseSystemPreview = (file: RemovableFileInfo): boolean => {
    const extension = MimeUtil.getExtensionWithoutDot(file.name)?.toLowerCase() || '';
    const systemPreviewableExtensions = [
      'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg',
      'pdf',
      'txt', 'md', 'json', 'xml', 'yaml', 'yml', 'js', 'ts', 'html', 'css',
      'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'
    ];
    return systemPreviewableExtensions.includes(extension);
  };

  fallbackPreview = (file: RemovableFileInfo, url: string) => {
    const extension = MimeUtil.getExtensionWithoutDot(file.name)?.toLowerCase() || '';
    const mimeType = MimeUtil.getMimeType(file.name) || '';
    
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(extension);
    const isPDF = extension === 'pdf';
    const isText = mimeType.startsWith('text/') || 
                   ['txt', 'md', 'json', 'xml', 'yaml', 'yml', 'js', 'ts', 'html', 'css'].includes(extension);
    
    if (isImage) {
      window.open(url, '_blank');
    } else if (isPDF) {
      window.open(url, '_blank');
    } else if (isText) {
      this.previewTextFile(file, url);
    } else {
      this.showPreviewNotSupported(file);
    }
  };

  previewTextFile = async (file: RemovableFileInfo, url: string) => {
    try {
      this.setState({ previewLoading: true });
      
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(Lang.t('error.operationFailed') + `: HTTP${response.status}`);
      }
      
      const blob = await response.blob();
      const text = await blob.slice(0, 100 * 1024).text();
      
      this.setState({
        previewModalVisible: true,
        previewData: {
          name: file.name,
          content: text,
          previewType: 'text',
          canPreview: true
        },
        previewLoading: false
      });
    } catch (error: any) {
      MessageBoxUtil.error(Lang.t('removable.previewFailed') + `: ${error.message}`);
      this.setState({ previewLoading: false });
    }
  };

  getFileDownloadUrl = (deviceId: string, filePath: string, callback: (url: string) => void) => {
    const params = new URLSearchParams({ deviceId, path: filePath });
    const url = `/api/removable/download?${params.toString()}`;
    callback(url);
  };

  canFilePreview = (file: RemovableFileInfo): boolean => {
    if (file.isDir) return false;
  
    const extension = MimeUtil.getExtensionWithoutDot(file.name)?.toLowerCase() || '';
  
    // 完整支持的类型集合（与之前正确版本完全一致）
    const supportedExtensions = new Set([
      // 图片
      'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'svg', 'ico',
      // 文档
      'pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx', 'vsd', 'vsdx',
      // 文本 / 代码
      'txt', 'md', 'markdown', 'json', 'xml', 'yaml', 'yml', 'csv',
      'js', 'jsx', 'ts', 'tsx', 'html', 'htm', 'css', 'scss', 'less',
      'java', 'py', 'php', 'rb', 'go', 'rs', 'cpp', 'c', 'h',
      'sh', 'bash', 'ps1', 'bat', 'sql',
      // CAD
      'dxf', 'dwg',
      // 思维导图
      'xmind', 'mm', 'pos', 'eddx', 'mindmup',
      // 音频
      'mp3', 'wav', 'ogg', 'm4a', 'aac', 'flac',
      // 视频
      'mp4', 'webm', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'm4v'
    ]);
  
    return supportedExtensions.has(extension);
  };
// 辅助方法：判断是否为 Office 文件
private isOfficeFile(fileName: string): boolean {
  const officeExts = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.vsd', '.vsdx'];
  const lowerName = fileName.toLowerCase();
  return officeExts.some(ext => lowerName.endsWith(ext));
}
  getFileExtension = (filename: string): string => {
    const dotIndex = filename.lastIndexOf('.');
    if (dotIndex > -1) {
      return filename.substring(dotIndex + 1).toLowerCase();
    }
    return '';
  };

  handleRename = (file: RemovableFileInfo) => {
    this.setState({
      renameModalVisible: true,
      renamingFile: file,
      newFileName: file.name
    });
  };

  handleRenameConfirm = () => {
    const { renamingFile, newFileName, currentPath } = this.state;
    const deviceId = this.deviceId;
    
    if (!renamingFile || !deviceId) return;
    
    if (newFileName === renamingFile.name) {
      MessageBoxUtil.info(Lang.t('removable.nameNoChange'));
      return;
    }
    
    this.setState({ renameLoading: true });
    
    const oldPath = this.state.currentPath 
      ? `${this.state.currentPath}/${renamingFile.name}`
      : renamingFile.name;
    
    this.directRenameRequest(deviceId, oldPath, newFileName, currentPath);
  };

  directRenameRequest = async (deviceId: string, oldPath: string, newName: string, currentPath: string) => {
    try {
      const formData = new FormData();
      formData.append('deviceId', deviceId);
      formData.append('oldPath', oldPath);
      formData.append('newName', newName);
      
      const url = '/api/removable/rename';
      
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });
      
      const textResponse = await response.text();
      
      if (response.ok) {
        try {
          const jsonResponse = JSON.parse(textResponse);
          
          if (jsonResponse && jsonResponse.code === "OK") {
            MessageBoxUtil.success(Lang.t('removable.renameSuccess'));
            this.setState({
              renameModalVisible: false,
              renameLoading: false,
              renamingFile: null,
              newFileName: ''
            });
            this.browseDirectory(currentPath);
          } else {
            const errorMsg = jsonResponse?.msg || jsonResponse?.message || Lang.t('removable.renameFailed');
            MessageBoxUtil.error(errorMsg);
            this.setState({ renameLoading: false });
          }
        } catch (parseError) {
          MessageBoxUtil.error(Lang.t('error.invalidFormat'));
          this.setState({ renameLoading: false });
        }
      } else {
        MessageBoxUtil.error(Lang.t('error.operationFailed') + `: HTTP${response.status}`);
        this.setState({ renameLoading: false });
      }
    } catch (error: any) {
      MessageBoxUtil.error(error.message || Lang.t('error.networkError'));
      this.setState({ renameLoading: false });
    }
  };

  handleUpload = () => {
    this.setState({ uploadModalVisible: true, selectedFile: null });
  };

  handleUploadConfirm = () => {
    const { selectedFile, currentPath } = this.state;
    const deviceId = this.deviceId;
    
    if (!selectedFile || !deviceId) {
      MessageBoxUtil.error(Lang.t('removable.selectFileFirst'));
      return;
    }
    
    this.setState({ uploadLoading: true });
    this.directUploadRequestWithCorrectParams(deviceId, currentPath, selectedFile);
  };

  directUploadRequestWithCorrectParams = async (deviceId: string, parentPath: string, file: File) => {
    try {
      const formData = new FormData();
      formData.append('deviceId', deviceId);
      formData.append('targetDir', parentPath || '');
      formData.append('file', file);
  
      const url = '/api/removable/upload';
  
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });
  
      const textResponse = await response.text();
  
      let jsonResponse: any = null;
      try {
        jsonResponse = JSON.parse(textResponse);
      } catch (parseError) {
        MessageBoxUtil.error(Lang.t('error.operationFailed') + `: HTTP ${response.status}`);
        this.setState({ uploadLoading: false });
        return;
      }
  
      if (response.ok && jsonResponse && jsonResponse.code === 'OK') {
        MessageBoxUtil.success(Lang.t('removable.uploadSuccess'));
        this.setState({
          uploadModalVisible: false,
          uploadLoading: false,
          selectedFile: null,
        });
        setTimeout(() => {
          this.browseDirectory(parentPath);
        }, 1000);
      } else {
        const errorCode = jsonResponse?.code;
        const errorMsg = jsonResponse?.msg || jsonResponse?.message || Lang.t('removable.uploadFailed');
  
        if (errorCode === 'NO_UPLOAD_PERMISSION' || response.status === 403) {
          MessageBoxUtil.error(Lang.t('removable.noUploadPermission'));
        } else if (errorCode === 'FORBIDDEN_EXTENSION') {
          MessageBoxUtil.error(Lang.t('removable.forbiddenExtension') + ': ' + errorMsg);
        } else if (errorCode === 'INSUFFICIENT_SPACE') {
          MessageBoxUtil.error(Lang.t('removable.insufficientSpace'));
        } else {
          MessageBoxUtil.error(errorMsg);
        }
        this.setState({ uploadLoading: false });
      }
    } catch (error: any) {
      MessageBoxUtil.error(error.message || Lang.t('error.networkError'));
      this.setState({ uploadLoading: false });
    }
  };

  // 文件夹上传相关
  handleUploadFolderClick = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.setAttribute('webkitdirectory', '');
    input.setAttribute('directory', '');
    input.setAttribute('multiple', '');
    input.style.display = 'none';
    
    input.onchange = (e: Event) => {
      const target = e.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        this.handleUploadFolderFileSelect(target.files);
      }
      document.body.removeChild(input);
    };
    
    document.body.appendChild(input);
    input.click();
  };

  handleUploadFolderFileSelect = (fileList: FileList) => {
    const files: File[] = [];
    const paths: string[] = [];
    
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i];
      if (file.webkitRelativePath) {
        files.push(file);
        paths.push(file.webkitRelativePath);
      } else {
        files.push(file);
        paths.push(file.name);
      }
    }
    
    this.setState({
      uploadFolderModalVisible: true,
      uploadFolderFiles: files,
      uploadFolderPaths: paths,
      uploadFolderProgress: 0,
    });
  };

  handleUploadFolderConfirm = async () => {
    const { uploadFolderFiles, uploadFolderPaths, currentPath } = this.state;
    const deviceId = this.deviceId;
    
    if (!deviceId || uploadFolderFiles.length === 0) {
      MessageBoxUtil.error(Lang.t('removable.selectFolderFirst'));
      return;
    }
    
    this.setState({ uploadFolderLoading: true, uploadFolderProgress: 0 });
    
    try {
      const formData = new FormData();
      formData.append('deviceId', deviceId);
      formData.append('targetDir', currentPath || '');
      
      uploadFolderFiles.forEach(file => {
        formData.append('files[]', file);
      });
      uploadFolderPaths.forEach(path => {
        formData.append('paths[]', path);
      });
      
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/removable/upload-folder', true);
      xhr.withCredentials = true;
      
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = Math.round((e.loaded / e.total) * 100);
          this.setState({ uploadFolderProgress: percent });
        }
      };
      
      xhr.onload = () => {
        if (xhr.status === 200) {
          try {
            const response = JSON.parse(xhr.responseText);
            if (response.code === 'OK') {
              const data = response.data || {};
              const successCount = data.successCount || 0;
              const totalCount = data.totalCount || uploadFolderFiles.length;
              const failedFiles = data.failedFiles || [];
              
              if (failedFiles.length > 0) {
                message.warning(
                  Lang.t('removable.uploadFolderPartial')
                    .replace('{0}', successCount.toString())
                    .replace('{1}', totalCount.toString())
                );
                console.warn('Failed files:', failedFiles);
              } else {
                message.success(
                  Lang.t('removable.uploadFolderSuccess')
                    .replace('{0}', successCount.toString())
                );
              }
              
              this.setState({
                uploadFolderModalVisible: false,
                uploadFolderFiles: [],
                uploadFolderPaths: [],
                uploadFolderLoading: false,
              });
              
              setTimeout(() => {
                this.browseDirectory(currentPath);
              }, 1000);
            } else {
              MessageBoxUtil.error(response.msg || Lang.t('removable.uploadFolderFailed'));
              this.setState({ uploadFolderLoading: false });
            }
          } catch (e) {
            MessageBoxUtil.error(Lang.t('error.invalidFormat'));
            this.setState({ uploadFolderLoading: false });
          }
        } else {
          MessageBoxUtil.error(Lang.t('error.operationFailed') + `: HTTP ${xhr.status}`);
          this.setState({ uploadFolderLoading: false });
        }
      };
      
      xhr.onerror = () => {
        MessageBoxUtil.error(Lang.t('error.networkError'));
        this.setState({ uploadFolderLoading: false });
      };
      
      xhr.send(formData);
    } catch (error: any) {
      console.error('Upload folder error:', error);
      MessageBoxUtil.error(error.message || Lang.t('error.operationFailed'));
      this.setState({ uploadFolderLoading: false });
    }
  };

  // ========== 删除 ==========
  handleDelete = (file?: RemovableFileInfo) => {
    if (file) {
      this.setState({ deleteModalVisible: true, deletingFiles: [file] });
    } else {
      const { selectedRowKeys, files } = this.state;
      const selectedFiles = files.filter(file => 
        selectedRowKeys.includes(file.path || '')
      );
      
      if (selectedFiles.length === 0) {
        MessageBoxUtil.info(Lang.t('removable.selectFilesFirst'));
        return;
      }
      
      this.setState({ deleteModalVisible: true, deletingFiles: selectedFiles });
    }
  };

  handleDeleteConfirm = () => {
    const { deletingFiles, currentPath } = this.state;
    const deviceId = this.deviceId;
    
    if (!deviceId || deletingFiles.length === 0) {
      this.setState({ deleteModalVisible: false, deletingFiles: [] });
      return;
    }
    
    this.setState({ deleteLoading: true });
    
    const deletePromises = deletingFiles.map(file => {
      const filePath = currentPath ? `${currentPath}/${file.name}` : file.name;
      return this.directDeleteRequestWithCorrectAPI(deviceId, filePath);
    });
    
    Promise.all(deletePromises)
      .then(results => {
        const successCount = results.filter(result => result).length;
        const failCount = results.length - successCount;
        
        if (successCount > 0) {
          message.success(Lang.t('operations.success') + ` ${successCount} ` + Lang.t('common.unit'));
        }
        
        if (failCount > 0) {
          message.error(`${failCount} ` + Lang.t('removable.unit') + Lang.t('error.operationFailed'));
        }
        
        this.setState({
          deleteModalVisible: false,
          deleteLoading: false,
          deletingFiles: [],
          selectedRowKeys: []
        });
        
        setTimeout(() => {
          this.browseDirectory(currentPath);
        }, 1000);
      })
      .catch(error => {
        MessageBoxUtil.error(Lang.t('error.operationFailed'));
        this.setState({ deleteLoading: false });
      });
  };

  directDeleteRequestWithCorrectAPI = async (deviceId: string, path: string): Promise<boolean> => {
    try {
      const formData = new FormData();
      formData.append('deviceId', deviceId);
      formData.append('path', path);
      
      let url = '/api/removable/delete';
      let response = await fetch(url, {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });
      
      let textResponse = await response.text();
      
      if (response.status === 404) {
        const params = new URLSearchParams({ deviceId, path });
        url = `/api/removable/delete?${params.toString()}`;
        response = await fetch(url, {
          method: 'POST',
          credentials: 'include',
        });
        textResponse = await response.text();
      }
      
      if (response.ok) {
        try {
          const jsonResponse = JSON.parse(textResponse);
          return jsonResponse && jsonResponse.code === "OK";
        } catch (parseError) {
          return textResponse.includes('success') || textResponse.includes('OK');
        }
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };

  handleCreateDirectory = () => {
    this.setState({ createDirModalVisible: true, newDirName: '' });
  };

  handleCreateDirectoryConfirm = () => {
    const { newDirName, currentPath } = this.state;
    const deviceId = this.deviceId;
    
    if (!newDirName) {
      MessageBoxUtil.error(Lang.t('removable.dirNameRequired'));
      return;
    }
    
    if (!deviceId) {
      MessageBoxUtil.error(Lang.t('error.invalidInput'));
      return;
    }
    
    if (!/^[^\\/:*?"<>|]+$/.test(newDirName)) {
      MessageBoxUtil.error(Lang.t('error.invalidFormat'));
      return;
    }
    
    this.setState({ createDirLoading: true });
    this.directCreateDirectoryRequestWithCorrectParams(deviceId, currentPath, newDirName);
  };

  directCreateDirectoryRequestWithCorrectParams = async (deviceId: string, parentPath: string, dirName: string) => {
    try {
      const formData = new FormData();
      formData.append('deviceId', deviceId);
      formData.append('parentPath', parentPath || '');
      formData.append('dirName', dirName);
      
      const response = await fetch('/api/removable/mkdir', {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });
      
      const textResponse = await response.text();
      
      if (response.ok) {
        try {
          const jsonResponse = JSON.parse(textResponse);
          
          if (jsonResponse && jsonResponse.code === "OK") {
            MessageBoxUtil.success(Lang.t('removable.createDirSuccess'));
            
            this.setState({
              createDirModalVisible: false,
              createDirLoading: false,
              newDirName: ''
            });
            
            setTimeout(() => {
              this.browseDirectory(parentPath);
            }, 1000);
          } else {
            const errorMsg = jsonResponse?.message || jsonResponse?.msg || Lang.t('error.operationFailed');
            MessageBoxUtil.error(errorMsg);
            this.setState({ createDirLoading: false });
          }
        } catch (parseError) {
          MessageBoxUtil.error(Lang.t('error.invalidFormat'));
          this.setState({ createDirLoading: false });
        }
      } else {
        const errorMsg = Lang.t('error.operationFailed') + `: HTTP${response.status}`;
        try {
          const jsonResponse = JSON.parse(textResponse);
          if (jsonResponse && jsonResponse.msg) {
            MessageBoxUtil.error(jsonResponse.msg);
          } else {
            MessageBoxUtil.error(errorMsg);
          }
        } catch (e) {
          MessageBoxUtil.error(errorMsg);
        }
        this.setState({ createDirLoading: false });
      }
    } catch (error: any) {
      MessageBoxUtil.error(error.message || Lang.t('error.networkError'));
      this.setState({ createDirLoading: false });
    }
  };

  refreshDeviceInfo = async (): Promise<boolean> => {
    const deviceId = this.deviceId;
    if (!deviceId) return false;
    
    try {
      const response = await fetch('/api/removable/list', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });
      
      if (response.ok) {
        const jsonResponse = await response.json();
        if (jsonResponse && jsonResponse.code === "OK" && Array.isArray(jsonResponse.data)) {
          const devices = jsonResponse.data.map((deviceData: any) => {
            return new RemovableStorage().safeAssign(deviceData);
          });
          
          const device = devices.find((d: RemovableStorage) => d.deviceId === deviceId);
          if (device) {
            this.setState({ currentDevice: device });
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  handleFileSelect = (file: File) => {
    this.setState({ selectedFile: file });
    return false;
  };

  handleSelectionChange = (selectedRowKeys: React.Key[]) => {
    this.setState({ selectedRowKeys });
  };

  previewTextContent = async (file: RemovableFileInfo, previewUrl: string) => {
    try {
      this.setState({ previewLoading: true });
      
      const response = await fetch(previewUrl);
      if (!response.ok) {
        throw new Error(Lang.t('error.operationFailed') + `: HTTP${response.status}`);
      }
      
      const text = await response.text();
      const truncatedText = text.length > 100 * 1024 
        ? text.substring(0, 100 * 1024) + '\n\n... (' + Lang.t('plugin.clickRefresh') + ')' 
        : text;
      
      this.setState({
        previewModalVisible: true,
        previewData: {
          name: file.name,
          content: truncatedText,
          previewType: 'text',
          canPreview: true
        },
        previewLoading: false
      });
    } catch (error: any) {
      this.setState({ previewLoading: false });
      message.error(Lang.t('removable.previewFailed') + ': ' + error.message);
    }
  };

  fallbackBrowserPreview = (file: RemovableFileInfo, previewUrl: string, extension: string) => {
    const isImage = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'svg'].includes(extension);
    const isPdf = extension === 'pdf';
    const isText = ['txt', 'md', 'json', 'xml', 'html', 'css', 'js', 'ts'].includes(extension);
    
    if (isImage) {
      this.previewWithIframe(file, previewUrl, Lang.t('matter.imageText'));
    } else if (isPdf) {
      this.previewWithEmbed(file, previewUrl);
    } else if (isText) {
      this.previewTextContent(file, previewUrl);
    } else {
      this.showPreviewNotSupported(file);
    }
  };

  previewWithIframe = (file: RemovableFileInfo, previewUrl: string, title: string) => {
    const iframeHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${title}: ${file.name}</title>
          <style>
            body { margin: 0; padding: 0; background: #f5f5f5; }
            .container { max-width: 100%; max-height: 100vh; text-align: center; }
            img { max-width: 100%; max-height: 95vh; object-fit: contain; }
            .toolbar { 
              background: white; 
              padding: 10px; 
              text-align: center; 
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
              position: fixed;
              bottom: 0;
              width: 100%;
              z-index: 1000;
            }
            .toolbar button {
              margin: 0 5px;
              padding: 8px 16px;
              border: 1px solid #1890ff;
              background: white;
              color: #1890ff;
              border-radius: 4px;
              cursor: pointer;
            }
            .toolbar button:hover {
              background: #1890ff;
              color: white;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <img src="${previewUrl}" alt="${file.name}" onerror="this.onerror=null;this.src='data:image/svg+xml;utf8,<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"400\\" height=\\"300\\"><rect width=\\"100%\\" height=\\"100%\\" fill=\\"%23f0f0f0\\"/><text x=\\"50%\\" y=\\"50%\\" text-anchor=\\"middle\\" dy=\\".3em\\" font-family=\\"Arial\\" font-size=\\"16\\" fill=\\"%23999\\">' + Lang.t('removable.previewFailed') + '</text></svg>'">
          </div>
          <div class="toolbar">
            <button onclick="window.print()">` + Lang.t('matter.print') + `</button>
            <button onclick="location.href='${previewUrl.replace('preview=true', 'download=true')}'" download="${file.name}">` + Lang.t('removable.download') + `</button>
            <button onclick="window.close()">` + Lang.t('close') + `</button>
          </div>
        </body>
      </html>
    `;
    
    const previewWindow = window.open('', '_blank');
    if (previewWindow) {
      previewWindow.document.write(iframeHtml);
      previewWindow.document.close();
    }
  };

  previewWithEmbed = (file: RemovableFileInfo, previewUrl: string) => {
    const pdfHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>` + Lang.t('matter.pdfText') + `: ${file.name}</title>
          <style>
            body { margin: 0; padding: 0; background: #525659; }
            embed { width: 100%; height: 100vh; }
            .toolbar { 
              background: white; 
              padding: 10px; 
              text-align: center; 
              box-shadow: 0 2px 8px rgba(0,0,0,0.1);
              position: fixed;
              top: 0;
              width: 100%;
              z-index: 1000;
            }
            .toolbar button {
              margin: 0 5px;
              padding: 8px 16px;
              border: 1px solid #1890ff;
              background: white;
              color: #1890ff;
              border-radius: 4px;
              cursor: pointer;
            }
            .toolbar button:hover {
              background: #1890ff;
              color: white;
            }
          </style>
        </head>
        <body>
          <div class="toolbar">
            <span style="margin-right: 20px; font-weight: bold;">${file.name}</span>
            <button onclick="document.querySelector('embed').style.height='calc(100vh - 50px)'; this.style.display='none';">` + Lang.t('matter.previewFile') + `</button>
            <button onclick="location.href='${previewUrl.replace('preview=true', 'download=true')}'" download="${file.name}">` + Lang.t('removable.download') + `</button>
            <button onclick="window.close()">` + Lang.t('close') + `</button>
          </div>
          <embed src="${previewUrl}" type="application/pdf" style="margin-top: 50px;">
        </body>
      </html>
    `;
    
    const previewWindow = window.open('', '_blank');
    if (previewWindow) {
      previewWindow.document.write(pdfHtml);
      previewWindow.document.close();
    }
  };

  // ========== 拖拽上传 ==========
  handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = 'copy';
  };

  handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const items = e.dataTransfer.items;
    if (!items || items.length === 0) {
      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.uploadDroppedFile(files[i]);
        }
      }
      return;
    }

    const entries: FileSystemEntry[] = [];
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      const entry = item.webkitGetAsEntry ? item.webkitGetAsEntry() : null;
      if (entry) {
        entries.push(entry);
      } else if (item.kind === 'file') {
        const file = item.getAsFile();
        if (file) {
          this.uploadDroppedFile(file);
        }
      }
    }

    entries.forEach(entry => {
      this.traverseFileTree(entry, '');
    });
  };

  traverseFileTree = (entry: FileSystemEntry, path: string) => {
    if (entry.isFile) {
      (entry as FileSystemFileEntry).file(file => {
        const relativePath = path ? `${path}/${entry.name}` : entry.name;
        this.uploadDroppedFile(file, relativePath);
      });
    } else if (entry.isDirectory) {
      const dirReader = (entry as FileSystemDirectoryEntry).createReader();
      dirReader.readEntries(entries => {
        entries.forEach(subEntry => {
          const subPath = path ? `${path}/${entry.name}` : entry.name;
          this.traverseFileTree(subEntry, subPath);
        });
      });
    }
  };

  uploadDroppedFile = (file: File, relativePath?: string) => {
    const deviceId = this.deviceId;
    const currentPath = this.state.currentPath || '';
    if (!deviceId) return;

    if (relativePath && relativePath.includes('/')) {
      message.info(Lang.t('removable.folderDragHint'));
      return;
    }

    this.directUploadRequestWithCorrectParams(deviceId, currentPath, file);
  };

  // ========== 视图模式切换 ==========
  toggleViewMode = (mode: 'list' | 'grid') => {
    localStorage.setItem('removable_view_mode', mode);
    this.setState({ viewMode: mode });
  };

/**
 * 渲染文件图标 - 基于扩展名手动映射到 Ant Design 图标
 */
renderFileIcon = (file: RemovableFileInfo, size: number = 20) => {
  const iconStyle = { fontSize: size, marginRight: 8 };
  
  // 目录
  if (file.isDir) {
    return <FolderOutlined style={{ ...iconStyle, color: '#ffa940' }} />;
  }
  
  // 提取扩展名
  let extension = '';
  if (file.extension) {
    extension = file.extension.toLowerCase();
  } else if (file.name) {
    const dotIndex = file.name.lastIndexOf('.');
    if (dotIndex > -1) extension = file.name.substring(dotIndex + 1).toLowerCase();
  }
  
  if (!extension) return <FileOutlined style={iconStyle} />;
  
  // 图片
  const imageExts = ['jpg','jpeg','png','gif','bmp','webp','tiff','svg','ico','heic','heif'];
  if (imageExts.includes(extension)) {
    return <FileImageOutlined style={{ ...iconStyle, color: '#52c41a' }} />;
  }
  
  // 视频
  const videoExts = ['mp4','webm','mov','avi','mkv','flv','wmv','m4v','3gp','mpeg','mpg'];
  if (videoExts.includes(extension)) {
    return <VideoCameraOutlined style={{ ...iconStyle, color: '#eb2f96' }} />;
  }
  
  // 音频
  const audioExts = ['mp3','wav','ogg','m4a','aac','flac','wma','aiff'];
  if (audioExts.includes(extension)) {
    return <AudioOutlined style={{ ...iconStyle, color: '#13c2c2' }} />;
  }
  
  // PDF
  if (extension === 'pdf') {
    return <FilePdfOutlined style={{ ...iconStyle, color: '#ff4d4f' }} />;
  }
  
  // Word
  if (extension === 'doc' || extension === 'docx') {
    return <FileWordOutlined style={{ ...iconStyle, color: '#1890ff' }} />;
  }
  
  // Excel
  if (['xls', 'xlsx', 'xlsm', 'csv'].includes(extension)) {
    return <FileExcelOutlined style={{ ...iconStyle, color: '#52c41a' }} />;
  }
  
  // PowerPoint
  if (['ppt', 'pptx', 'pptm'].includes(extension)) {
    return <FilePptOutlined style={{ ...iconStyle, color: '#ff4d4f' }} />;
  }
  
  // 压缩包
  const archiveExts = ['zip','rar','7z','tar','gz','bz2','xz'];
  if (archiveExts.includes(extension)) {
    return <FileZipOutlined style={{ ...iconStyle, color: '#722ed1' }} />;
  }
  
  // 文本 / 代码
  const textExts = [
    'txt', 'md', 'markdown', 'json', 'xml', 'yaml', 'yml', 'toml', 'ini', 'conf',
    'js', 'jsx', 'ts', 'tsx', 'html', 'htm', 'css', 'scss', 'less',
    'java', 'py', 'go', 'rs', 'c', 'cpp', 'h', 'hpp', 'cs', 'php', 'rb', 'swift',
    'sh', 'bash', 'ps1', 'bat', 'cmd', 'sql', 'log'
  ];
  if (textExts.includes(extension)) {
    return <FileTextOutlined style={{ ...iconStyle, color: '#faad14' }} />;
  }
  
  // 默认文件图标
  return <FileOutlined style={iconStyle} />;
};

// 判断文件是否为图片（基于扩展名）
private isImageFile(file: RemovableFileInfo): boolean {
  const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff', 'svg', 'ico'];
  const ext = this.getFileExtension(file.name);
  return imageExts.includes(ext);
}


/**
 * 网格视图渲染
 * 支持文件/目录卡片展示，图片文件显示缩略图（调用移动盘缩略图接口）
 */
renderGridView = () => {
  const { files, loading, selectedRowKeys } = this.state;
  const deviceId = this.deviceId; // 当前设备ID

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>{Lang.t('loading')}</div>
      </div>
    );
  }

  if (files.length === 0) {
    return <Empty description={Lang.t('removable.emptyDirectory')} />;
  }

  return (
    <Row gutter={[16, 16]} className="removable-grid-view">
      {files.map((file) => {
        const key = file.path || file.name;
        const isSelected = selectedRowKeys.includes(key);
        // 构建文件在移动盘中的完整路径（用于缩略图接口和下载/预览）
        const fileFullPath = this.state.currentPath
          ? `${this.state.currentPath}/${file.name}`
          : file.name;
        // 是否为图片文件（仅当文件非目录且扩展名为图片类型）
        const isImageFile = !file.isDir && this.isImageFile(file);
        // 缩略图 URL（如果后端尚未实现接口，可先注释；实现后放开）
        const thumbnailUrl = isImageFile
          ? `/api/removable/thumbnail?deviceId=${deviceId}&path=${encodeURIComponent(fileFullPath)}`
          : '';

        // 右键菜单（阻止事件冒泡，避免点击菜单时触发卡片点击事件）
        const menu = (
          <Menu>
            {!file.isDir && (
              <Menu.Item
                key="download"
                icon={<DownloadOutlined />}
                onClick={(e) => {
                  e.domEvent?.stopPropagation();
                  this.handleDownload(file);
                }}
              >
                {Lang.t('removable.download')}
              </Menu.Item>
            )}
            <Menu.Item
              key="preview"
              icon={<EyeOutlined />}
              disabled={!this.canFilePreview(file)}
              onClick={(e) => {
                e.domEvent?.stopPropagation();
                this.handlePreview(file);
              }}
            >
              {Lang.t('matter.preview')}
            </Menu.Item>
            <Menu.Item
              key="rename"
              icon={<EditOutlined />}
              onClick={(e) => {
                e.domEvent?.stopPropagation();
                this.handleRename(file);
              }}
            >
              {Lang.t('removable.rename')}
            </Menu.Item>
            {file.isDir && (
              <Menu.Item
                key="open"
                icon={<FolderOpenOutlined />}
                onClick={(e) => {
                  e.domEvent?.stopPropagation();
                  this.handleDirectoryClick(file);
                }}
              >
                {Lang.t('removable.open')}
              </Menu.Item>
            )}
            <Menu.Divider />
            <Menu.Item
              key="delete"
              icon={<DeleteOutlined />}
              danger
              onClick={(e) => {
                e.domEvent?.stopPropagation();
                this.handleDelete(file);
              }}
            >
              {Lang.t('matter.delete')}
            </Menu.Item>
          </Menu>
        );

        return (
          <Col key={key} xs={12} sm={8} md={6} lg={4} xl={3}>
            <Card
              className="removable-grid-card"
              hoverable
              size="small"
              onClick={() => {
                if (file.isDir) this.handleDirectoryClick(file);
                else this.handlePreview(file);
              }}
              cover={
                <div
                  className="grid-card-cover"
                  style={{
                    textAlign: 'center',
                    padding: '24px 0 8px',
                    height: 150,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {isImageFile ? (
                    <img
                      src={thumbnailUrl}
                      alt={file.name}
                      style={{ maxWidth: '100%', maxHeight: 120, objectFit: 'contain' }}
                      onError={(e) => {
                        // 缩略图加载失败时隐藏图片，显示默认图标
                        e.currentTarget.style.display = 'none';
                        // 显示图标（需要获取图标元素并显示）
                        const iconContainer = e.currentTarget.parentElement?.querySelector('.fallback-icon');
                        if (iconContainer) iconContainer.setAttribute('style', 'display:flex');
                      }}
                    />
                  ) : null}
                  <div
                    className="fallback-icon"
                    style={{
                      display: isImageFile ? 'none' : 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    {this.renderFileIcon(file, 48)}
                  </div>
                </div>
              }
              actions={[
                <Checkbox
                  checked={isSelected}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    let newKeys = [...selectedRowKeys];
                    if (e.target.checked) {
                      if (!newKeys.includes(key)) newKeys.push(key);
                    } else {
                      newKeys = newKeys.filter(k => k !== key);
                    }
                    this.setState({ selectedRowKeys: newKeys });
                  }}
                />,
                <Tooltip title={Lang.t('matter.preview')}>
                  <EyeOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handlePreview(file);
                    }}
                  />
                </Tooltip>,
                <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
                  <MoreOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  />
                </Dropdown>,
              ]}
            >
              <Card.Meta
                title={
                  <div
                    className="grid-file-name"
                    style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    title={file.name}
                  >
                    {file.name}
                  </div>
                }
                description={
                  <div style={{ fontSize: 12, color: '#888' }}>
                    {!file.isDir && (
                      <div>{RemovableStorage.formatSizeStatic(file.size || 0)}</div>
                    )}
                    {file.modifiedTime && (
                      <div>{new Date(file.modifiedTime).toLocaleDateString()}</div>
                    )}
                  </div>
                }
              />
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};
  // ========== 渲染 ==========
  renderDeviceList = () => {
    const { devices, loading } = this.state;
  
    return (
      <div>
        <div className="page-title">
          <h2>
            <UsbOutlined style={{ marginRight: 8 }} />
            {Lang.t('removable.storageManagement')}
          </h2>
        </div>
        
        <Card>
          <div style={{ marginBottom: 16 }}>
            <Button 
              type="primary" 
              onClick={this.loadDeviceList}
              loading={loading}
              icon={<ReloadOutlined />}
            >
              {Lang.t('removable.refreshDevices')}
            </Button>
          </div>
          
          {loading ? (
            <div style={{ textAlign: 'center', padding: 50 }}>
              <Spin size="large" />
              <div style={{ marginTop: 16 }}>{Lang.t('loading')}</div>
            </div>
          ) : devices.length === 0 ? (
            <Empty
              description={
                <div>
                  <div>{Lang.t('removable.noDeviceFound')}</div>
                  <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
                    {Lang.t('attention')}
                  </div>
                </div>
              }
            />
          ) : (
            <div style={{ marginTop: 16 }}>
              <h3>{Lang.t('removable.deviceList')} ({devices.length})</h3>
              <Row gutter={[16, 16]}>
                {devices.map((device, index) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={index}>
                    <Card
                      hoverable
                      onClick={() => this.handleDeviceClick(device)}
                      style={{ height: '100%', cursor: 'pointer' }}
                    >
                      <div style={{ textAlign: 'center' }}>
                        {device.isRemovable ? (
                          <UsbOutlined style={{ fontSize: 48, color: '#1890ff', marginBottom: 16 }} />
                        ) : (
                          <HddOutlined style={{ fontSize: 48, color: '#52c41a', marginBottom: 16 }} />
                        )}
                        
                        <h4>{device.name}</h4>
                        
                        <div style={{ textAlign: 'left', marginTop: 16 }}>
                          <p><strong>{Lang.t('removable.deviceName')}:</strong> {device.deviceId || 'N/A'}</p>
                          <p><strong>{Lang.t('removable.mountPoint')}:</strong> {device.mountPoint || 'N/A'}</p>
                          <p><strong>{Lang.t('removable.fileSystem')}:</strong> {device.fileSystem || 'N/A'}</p>
                          <p><strong>{Lang.t('removable.totalCapacity')}:</strong> {device.getFormattedTotalSize()}</p>
                          <p><strong>{Lang.t('removable.availableSpace')}:</strong> {device.getFormattedFreeSize()}</p>
                          <p><strong>{Lang.t('removable.status')}:</strong> 
                            <Tag color={device.status === 'connected' ? 'success' : 'error'} style={{ marginLeft: 8 }}>
                              {device.status || Lang.t('matter.unknown')}
                            </Tag>
                          </p>
                        </div>
                        
                        <Button 
                          type="primary" 
                          style={{ marginTop: 16 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.handleDeviceClick(device);
                          }}
                          disabled={!device.deviceId}
                        >
                          {Lang.t('removable.browse')}
                        </Button>
                      </div>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </Card>
      </div>
    );
  };

  renderBreadcrumb = () => {
    const { currentDevice, currentPath } = this.state;
    
    const pathParts = currentPath ? currentPath.split('/') : [];
    
    return (
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]} align="middle">
          <Col flex="auto">
            <Breadcrumb>
              <Breadcrumb.Item 
                onClick={this.handleGoHome} 
                className="breadcrumb-item-clickable"
              >
                <HomeOutlined /> {currentDevice?.name || Lang.t('removable.device')}
              </Breadcrumb.Item>
              {pathParts.map((part, index) => {
                const path = pathParts.slice(0, index + 1).join('/');
                return (
                  <Breadcrumb.Item 
                    key={index}
                    onClick={() => this.browseDirectory(path)}
                    className="breadcrumb-item-clickable"
                  >
                    {part}
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
            <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
              {currentDevice?.mountPoint}
              {currentPath && `/${currentPath}`}
            </div>
          </Col>
          
          <Col>
            <AntdSpace>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={this.handleGoBack}
                disabled={!currentPath}
              >
                {Lang.t('removable.goBack')}
              </Button>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => this.browseDirectory(this.state.currentPath)}
                loading={this.state.loading}
              >
                {Lang.t('refresh')}
              </Button>
            </AntdSpace>
          </Col>
        </Row>
      </Card>
    );
  };

  renderFileActions = (file: RemovableFileInfo) => {
    const menu = (
      <Menu>
        {!file.isDir && (
          <Menu.Item 
            key="download" 
            icon={<DownloadOutlined />} 
            onClick={(e) => {
              e.domEvent?.stopPropagation();
              this.handleDownload(file);
            }}
          >
            {Lang.t('removable.download')}
          </Menu.Item>
        )}
        <Menu.Item 
          key="preview" 
          icon={<EyeOutlined />} 
          disabled={!this.canFilePreview(file)}
          onClick={(e) => {
            e.domEvent?.stopPropagation();
            this.handlePreview(file);
          }}
        >
          {Lang.t('matter.preview')}
        </Menu.Item>
        <Menu.Item 
          key="rename" 
          icon={<EditOutlined />} 
          onClick={(e) => {
            e.domEvent?.stopPropagation();
            this.handleRename(file);
          }}
        >
          {Lang.t('removable.rename')}
        </Menu.Item>
        {file.isDir && (
          <Menu.Item 
            key="open" 
            icon={<FolderOpenOutlined />} 
            onClick={(e) => {
              e.domEvent?.stopPropagation();
              this.handleDirectoryClick(file);
            }}
          >
            {Lang.t('removable.open')}
          </Menu.Item>
        )}
        <Menu.Divider />
        <Menu.Item 
          key="delete" 
          icon={<DeleteOutlined />} 
          danger
          onClick={(e) => {
            e.domEvent?.stopPropagation();
            this.handleDelete(file);
          }}
        >
          {Lang.t('matter.delete')}
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown 
        overlay={menu} 
        trigger={['click']}
        placement="bottomRight"
      >
        <Button 
          type="text" 
          size="small" 
          icon={<MoreOutlined />}
          style={{ 
            display: 'inline-block',
            visibility: 'visible',
            opacity: 1,
            color: '#666',
            fontSize: '16px',
            padding: '0 8px',
            width: '32px',
            height: '32px',
            lineHeight: '32px'
          }}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        />
      </Dropdown>
    );
  };

  renderToolbar = () => {
    const { selectedRowKeys, files, viewMode } = this.state;
    const selectedFiles = files.filter(file => 
      selectedRowKeys.includes(file.path || '')
    );
    const hasPreviewableFiles = selectedFiles.some(file => !file.isDir && this.canFilePreview(file));
  
    return (
      <Card size="small" style={{ marginBottom: 16 }}>
        <Row gutter={[16, 16]} align="middle">
          <Col flex="auto">
            <AntdSpace wrap>
              {/* 视图切换按钮组 */}
              <Button.Group className="view-toggle-buttons">
                <Tooltip title={Lang.t('matter.listView')}>
                  <Button
                    type={viewMode === 'list' ? 'primary' : 'default'}
                    icon={<BarsOutlined />}
                    onClick={() => this.toggleViewMode('list')}
                  />
                </Tooltip>
                <Tooltip title={Lang.t('matter.gridView')}>
                  <Button
                    type={viewMode === 'grid' ? 'primary' : 'default'}
                    icon={<AppstoreOutlined />}
                    onClick={() => this.toggleViewMode('grid')}
                  />
                </Tooltip>
              </Button.Group>
  
              {/* 全选复选框（仅在文件列表非空时显示） */}
              {files.length > 0 && (
                <Checkbox
                  indeterminate={selectedRowKeys.length > 0 && selectedRowKeys.length < files.length}
                  checked={selectedRowKeys.length === files.length && files.length > 0}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const allKeys = files.map(f => f.path || f.name);
                      this.setState({ selectedRowKeys: allKeys });
                    } else {
                      this.setState({ selectedRowKeys: [] });
                    }
                  }}
                >
                  {Lang.t('selectAll')}
                </Checkbox>
              )}
  
              <Button
                type="primary"
                icon={<UploadOutlined />}
                onClick={this.handleUpload}
              >
                {Lang.t('removable.upload')}
              </Button>
              <Button
                icon={<FolderOpenOutlined />}
                onClick={this.handleUploadFolderClick}
              >
                {Lang.t('removable.uploadFolder')}
              </Button>
  
              {/* 选中后的操作按钮（仅显示一次） */}
              {selectedRowKeys.length > 0 && (
                <>
                  <Button
                    icon={<DownloadOutlined />}
                    onClick={() => this.handleDownload()}
                  >
                    {Lang.t('removable.downloadSelected')}
                  </Button>
                  <Button
                    icon={<EyeOutlined />}
                    onClick={() => {
                      const previewFile = selectedFiles.find(f => !f.isDir && this.canFilePreview(f));
                      if (previewFile) this.handlePreview(previewFile);
                    }}
                    disabled={!hasPreviewableFiles}
                  >
                    {Lang.t('removable.previewSelected')}
                  </Button>
                  <Button
                    icon={<DeleteOutlined />}
                    danger
                    onClick={() => this.handleDelete()}
                  >
                    {Lang.t('matter.delete')}
                  </Button>
                  <span>
                    {Lang.t('removable.selectedCount').replace('{0}', selectedFiles.length.toString())}
                  </span>
                </>
              )}
  
              <Button
                icon={<PlusOutlined />}
                onClick={this.handleCreateDirectory}
              >
                {Lang.t('log.createDirectory')}
              </Button>
            </AntdSpace>
          </Col>
  
          <Col>
            <div style={{ fontSize: 12, color: '#666' }}>
              {Lang.t('plugin.total')}: {files.length} {Lang.t('common.unit')}
            </div>
          </Col>
        </Row>
      </Card>
    );
  };
  renderPreviewModal = () => {
    const { previewModalVisible, previewData, previewLoading } = this.state;
    
    if (!previewModalVisible || !previewData) return null;
    
    const renderPreviewContent = () => {
      if (previewLoading) {
        return (
          <div style={{ textAlign: 'center', padding: 50 }}>
            <Spin size="large" />
            <div style={{ marginTop: 16 }}>{Lang.t('loading')}</div>
          </div>
        );
      }
      
      if (!previewData.canPreview) {
        return (
          <Empty
            description={
              <div>
                <div>{previewData.message || Lang.t('removable.cannotPreview')}</div>
                <div style={{ marginTop: 8 }}>
                  <Button 
                    type="primary" 
                    onClick={() => this.handleDownload(previewData)}
                  >
                    {Lang.t('removable.downloadInstead')}
                  </Button>
                </div>
              </div>
            }
          />
        );
      }
      
      switch (previewData.previewType) {
        case 'text':
          return (
            <pre style={{ 
              maxHeight: '60vh', 
              overflow: 'auto', 
              backgroundColor: '#f6f8fa',
              padding: 16,
              borderRadius: 4,
              whiteSpace: 'pre-wrap',
              wordWrap: 'break-word',
              fontFamily: 'Consolas, Monaco, "Courier New", monospace',
              fontSize: 14
            }}>
              {previewData.content}
            </pre>
          );
        case 'image':
          return (
            <div style={{ textAlign: 'center' }}>
              <img 
                src={previewData.content || previewData.url} 
                alt={previewData.name}
                style={{ maxWidth: '100%', maxHeight: '60vh' }}
              />
            </div>
          );
        case 'pdf':
          return (
            <div style={{ height: '60vh' }}>
              <iframe
                src={previewData.content || previewData.url}
                title={previewData.name}
                style={{ width: '100%', height: '100%', border: 'none' }}
              />
            </div>
          );
        default:
          return (
            <Empty description={
              <div>
                <div>{Lang.t('removable.unsupportedPreview')}</div>
                <div style={{ marginTop: 8 }}>
                  <Button 
                    type="primary" 
                    onClick={() => this.handleDownload(previewData)}
                  >
                    {Lang.t('removable.downloadInstead')}
                  </Button>
                </div>
              </div>
            } />
          );
      }
    };
    
    const footer = (
      <div>
        <Button 
          onClick={() => this.handleDownload(previewData)}
          icon={<DownloadOutlined />}
        >
          {Lang.t('removable.download')}
        </Button>
        <Button 
          type="primary" 
          onClick={() => this.setState({ 
            previewModalVisible: false, 
            previewData: null 
          })}
          style={{ marginLeft: 8 }}
        >
          {Lang.t('close')}
        </Button>
      </div>
    );
    
    return (
      <Modal
        title={
          <span>
            <EyeOutlined /> {previewData.name}
          </span>
        }
        visible={previewModalVisible}
        onCancel={() => this.setState({ 
          previewModalVisible: false, 
          previewData: null 
        })}
        width={800}
        footer={footer}
        bodyStyle={{ padding: 0 }}
      >
        {renderPreviewContent()}
      </Modal>
    );
  };

  renderMediaPreviewModal = () => {
    const { mediaPreviewVisible, mediaPreviewUrl, mediaPreviewType, mediaPreviewName, mediaPreviewMimeType } = this.state;
    
    if (!mediaPreviewVisible) return null;
    
    const MediaElement = mediaPreviewType === 'audio' ? 'audio' : 'video';
    const modalTitle = mediaPreviewType === 'audio' ? Lang.t('removable.audio') : Lang.t('removable.video');
    
    return (
      <Modal
        title={
          <span>
            {mediaPreviewType === 'audio' ? <AudioOutlined /> : <VideoCameraOutlined />}
            {modalTitle}: {mediaPreviewName}
          </span>
        }
        visible={mediaPreviewVisible}
        onCancel={() => this.setState({ 
          mediaPreviewVisible: false,
          mediaPreviewUrl: '',
          mediaPreviewType: null,
          mediaPreviewName: '',
          mediaPreviewMimeType: ''
        })}
        width={800}
        footer={null}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ textAlign: 'center', padding: 20 }}>
          <MediaElement
            controls
            autoPlay
            style={{
              width: '100%',
              maxHeight: '60vh'
            }}
          >
            <source src={mediaPreviewUrl} type={mediaPreviewMimeType} />
            {Lang.t('removable.unsupportedPreview')}
          </MediaElement>
          <div style={{ marginTop: 16 }}>
            <Button 
              onClick={() => {
                const a = document.createElement('a');
                a.href = mediaPreviewUrl;
                a.download = mediaPreviewName;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
              }}
              icon={<DownloadOutlined />}
            >
              {Lang.t('removable.download')}
            </Button>
            <Button 
              type="primary" 
              onClick={() => this.setState({ 
                mediaPreviewVisible: false,
                mediaPreviewUrl: '',
                mediaPreviewType: null,
                mediaPreviewName: '',
                mediaPreviewMimeType: ''
              })}
              style={{ marginLeft: 8 }}
            >
              {Lang.t('close')}
            </Button>
          </div>
        </div>
      </Modal>
    );
  };

  renderRenameModal = () => {
    const { renameModalVisible, renameLoading, newFileName } = this.state;
    
    return (
      <Modal
        title={Lang.t('removable.renameFile')}
        visible={renameModalVisible}
        onOk={this.handleRenameConfirm}
        onCancel={() => this.setState({ renameModalVisible: false, newFileName: '' })}
        confirmLoading={renameLoading}
        okText={Lang.t('removable.rename')}
        cancelText={Lang.t('common.cancel')}
      >
        <Input
          value={newFileName}
          onChange={(e) => this.setState({ newFileName: e.target.value })}
          placeholder={Lang.t('removable.enterNewName')}
          onPressEnter={this.handleRenameConfirm}
        />
        <div style={{ fontSize: 12, color: '#666', marginTop: 8 }}>
          {Lang.t('removable.renameHint')}
        </div>
      </Modal>
    );
  };

  renderUploadModal = () => {
    const { uploadModalVisible, uploadLoading, selectedFile, currentPath } = this.state;
    
    return (
      <Modal
        title={Lang.t('removable.uploadFile')}
        visible={uploadModalVisible}
        onOk={this.handleUploadConfirm}
        onCancel={() => this.setState({ uploadModalVisible: false, selectedFile: null })}
        confirmLoading={uploadLoading}
        okText={Lang.t('removable.startUpload')}
        cancelText={Lang.t('common.cancel')}
      >
        <div>
          <div style={{ marginBottom: 16 }}>
            <strong>{Lang.t('removable.currentDirectory')}:</strong>
            <div style={{ marginTop: 4, padding: 8, backgroundColor: '#f6f6f6', borderRadius: 4 }}>
              {currentPath || Lang.t('removable.rootDirectory')}
            </div>
          </div>
          
          <div style={{ marginBottom: 16 }}>
            <strong>{Lang.t('removable.selectFile')}:</strong>
            <Upload
              beforeUpload={this.handleFileSelect}
              showUploadList={false}
              maxCount={1}
              style={{ marginTop: 8 }}
            >
              <Button icon={<UploadOutlined />}>
                {selectedFile 
                  ? selectedFile.name 
                  : Lang.t('removable.clickToSelectFile')
                }
              </Button>
            </Upload>
            
            {selectedFile && (
              <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
                {Lang.t('removable.fileSize')}: {RemovableStorage.formatSizeStatic(selectedFile.size)}
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  };

  renderUploadFolderModal = () => {
    const {
      uploadFolderModalVisible,
      uploadFolderLoading,
      uploadFolderFiles,
      uploadFolderProgress,
      currentPath
    } = this.state;
    
    const totalSize = uploadFolderFiles.reduce((sum, file) => sum + file.size, 0);
    
    return (
      <Modal
        title={Lang.t('removable.uploadFolder')}
        visible={uploadFolderModalVisible}
        onOk={this.handleUploadFolderConfirm}
        onCancel={() => this.setState({
          uploadFolderModalVisible: false,
          uploadFolderFiles: [],
          uploadFolderPaths: []
        })}
        confirmLoading={uploadFolderLoading}
        okText={Lang.t('removable.startUpload')}
        cancelText={Lang.t('common.cancel')}
        width={600}
      >
        <div>
          <div style={{ marginBottom: 16 }}>
            <strong>{Lang.t('removable.currentDirectory')}:</strong>
            <div style={{ marginTop: 4, padding: 8, backgroundColor: '#f6f6f6', borderRadius: 4 }}>
              {currentPath || Lang.t('removable.rootDirectory')}
            </div>
          </div>
          
          {uploadFolderFiles.length > 0 && (
            <>
              <div style={{ marginBottom: 8 }}>
                <strong>{Lang.t('removable.selectedFiles')}:</strong> {uploadFolderFiles.length} {Lang.t('common.unit')}
                （{RemovableStorage.formatSizeStatic(totalSize)}）
              </div>
              
              <div style={{ maxHeight: 300, overflow: 'auto', border: '1px solid #f0f0f0', borderRadius: 4, padding: 8 }}>
                {uploadFolderFiles.slice(0, 20).map((file, index) => (
                  <div key={index} style={{ fontSize: 13, padding: '4px 0', borderBottom: '1px dashed #f0f0f0' }}>
                    {file.name}
                  </div>
                ))}
                {uploadFolderFiles.length > 20 && (
                  <div style={{ color: '#999', padding: 8, textAlign: 'center' }}>
                    ... 等 {uploadFolderFiles.length - 20} {Lang.t('common.unit')}
                  </div>
                )}
              </div>
              
              {uploadFolderLoading && (
                <div style={{ marginTop: 16 }}>
                  <Progress percent={uploadFolderProgress} status="active" />
                </div>
              )}
            </>
          )}
        </div>
      </Modal>
    );
  };

  renderCreateDirModal = () => {
    const { createDirModalVisible, createDirLoading, newDirName } = this.state;
    
    return (
      <Modal
        title={Lang.t('log.createDirectory')}
        visible={createDirModalVisible}
        onOk={this.handleCreateDirectoryConfirm}
        onCancel={() => this.setState({ 
          createDirModalVisible: false, 
          newDirName: '' 
        })}
        confirmLoading={createDirLoading}
        okText={Lang.t('log.createDirectory')}
        cancelText={Lang.t('common.cancel')}
      >
        <Input
          value={newDirName}
          onChange={(e) => this.setState({ newDirName: e.target.value })}
          placeholder={Lang.t('removable.enterDirName')}
          onPressEnter={this.handleCreateDirectoryConfirm}
        />
      </Modal>
    );
  };

  renderDeleteModal = () => {
    const { deleteModalVisible, deleteLoading, deletingFiles } = this.state;
    
    const fileNames = deletingFiles.map(file => file.name).join(', ');
    const isDir = deletingFiles.length === 1 && deletingFiles[0].isDir;
    
    return (
      <Modal
        title={Lang.t('removable.deleteConfirm')}
        visible={deleteModalVisible}
        onOk={this.handleDeleteConfirm}
        onCancel={() => this.setState({ 
          deleteModalVisible: false, 
          deletingFiles: [] 
        })}
        confirmLoading={deleteLoading}
        okText={Lang.t('matter.delete')}
        cancelText={Lang.t('common.cancel')}
        okButtonProps={{ danger: true }}
      >
        <div>
          <Alert
            type="warning"
            message={Lang.t('removable.deleteWarning')}
            showIcon
            style={{ marginBottom: 16 }}
          />
          
          <div>
            {Lang.t('common.confirm')} {Lang.t('matter.delete')}: <strong>{fileNames}</strong>
          </div>
          
          {isDir && (
            <div style={{ marginTop: 8, color: '#ff4d4f' }}>
              {Lang.t('removable.deleteDirWarning')}
            </div>
          )}
        </div>
      </Modal>
    );
  };

  renderFileBrowser = () => {
    const { currentDevice, files, loading, selectedRowKeys, viewMode } = this.state;
    
    const columns = [
      {
        title: Lang.t('removable.fileName'),
        dataIndex: 'name',
        width: '40%',
        render: (name: string, file: RemovableFileInfo) => (
          <div 
            style={{ 
              display: 'flex', 
              alignItems: 'center',
              cursor: (file.isDir || this.canFilePreview(file)) ? 'pointer' : 'default'
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (file.isDir) {
                this.handleDirectoryClick(file);
              } else if (this.canFilePreview(file)) {
                this.handlePreview(file);
              }
            }}
          >
            {this.renderFileIcon(file, 20)}
            <div>
              <div>{name}</div>
              {file.isDir && (
                <div style={{ fontSize: 12, color: '#666' }}>
                  {Lang.t('removable.directory')}
                </div>
              )}
            </div>
          </div>
        ),
      },
      {
        title: Lang.t('removable.size'),
        dataIndex: 'size',
        width: 120,
        align: 'right' as const,
        render: (size: number, file: RemovableFileInfo) => {
          if (file.isDir) {
            return <span>-</span>;
          }
          return <span>{RemovableStorage.formatSizeStatic(size || 0)}</span>;
        },
      },
      {
        title: Lang.t('removable.modifiedTime'),
        dataIndex: 'modifiedTime',
        width: 180,
        render: (modifiedTime: string, file: RemovableFileInfo) => {
          if (!modifiedTime) return <span>-</span>;
          try {
            return <span>{new Date(modifiedTime).toLocaleString()}</span>;
          } catch (e) {
            return <span>{modifiedTime}</span>;
          }
        },
      },
      {
        title: Lang.t('removable.type'),
        dataIndex: 'extension',
        width: 100,
        render: (extension: string, file: RemovableFileInfo) => {
          if (file.isDir) {
            return <Tag color="blue">{Lang.t('removable.directory')}</Tag>;
          }
          return <span>{(extension || Lang.t('matter.unknown')).toUpperCase()}</span>;
        },
      },
      {
        title: Lang.t('removable.operation'),
        width: 100,
        align: 'center' as const,
        fixed: 'right' as const,
        render: (file: RemovableFileInfo) => this.renderFileActions(file),
      },
    ];
    
    return (
      <div
        onDragOver={this.handleDragOver}
        onDrop={this.handleDrop}
        style={{ minHeight: '400px' }}
      >
        <div className="page-title">
          <div className="page-title-name">
            <h2>
              <FolderOpenOutlined style={{ marginRight: 8 }} />
              {currentDevice?.name || Lang.t('removable.fileBrowser')}
            </h2>
            <div className="page-title-desc">
              {Lang.t('removable.fileBrowserDesc')}
            </div>
          </div>
          
          <div className="page-title-action">
            <Button
              type="default"
              onClick={() => this.props.history.push('/removable/list')}
            >
              {Lang.t('removable.backToList')}
            </Button>
          </div>
        </div>

        {this.renderBreadcrumb()}
        
        {this.renderToolbar()}

        <Card>
          {viewMode === 'list' ? (
            <Table<RemovableFileInfo>
              rowKey={(record) => record.path || record.name}
              loading={loading}
              dataSource={files}
              columns={columns}
              pagination={false}
              locale={{
                emptyText: (
                  <Empty
                    description={
                      <div>
                        <div>{Lang.t('removable.emptyDirectory')}</div>
                        <div style={{ marginTop: 8, fontSize: 12, color: '#666' }}>
                          {Lang.t('removable.device')}: {currentDevice?.name || Lang.t('matter.unknown')} (ID: {this.deviceId || Lang.t('matter.unknown')})
                        </div>
                      </div>
                    }
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
              rowSelection={{
                selectedRowKeys,
                onChange: this.handleSelectionChange,
              }}
              scroll={{ x: 1000 }}
              size="middle"
            />
          ) : (
            this.renderGridView()
          )}
        </Card>
        
        {this.renderPreviewModal()}
        {this.renderMediaPreviewModal()}
        {this.renderRenameModal()}
        {this.renderUploadModal()}
        {this.renderUploadFolderModal()}
        {this.renderCreateDirModal()}
        {this.renderDeleteModal()}
      </div>
    );
  };

  render() {
    if (this.deviceId) {
      return (
        <div className="page-removable-file-browser">
          {this.renderFileBrowser()}
        </div>
      );
    }

    return (
      <div className="page-removable-file-browser">
        {this.renderDeviceList()}
      </div>
    );
  }
}